import * as React from "react"
import * as Sentry from "@sentry/browser"
import { User } from "@modules/graphql/types"

export function useTrackSentry(user: User | undefined) {
  const [isUserSet, setIsUserSet] = React.useState(false)

  React.useEffect(() => {
    if (!isUserSet && user && !user.banned) {
      Sentry.configureScope(scope => {
        scope.setUser({
          id: user?.id,
          username: user?.name,
          email: user?.email || undefined,
        })
      })
      setIsUserSet(true)
    }
  }, [user])

  const stopTrackingSentry = () => {
    // @ts-expect-error: use null is the proper example given by sentry to create data so we are turning off the typescript error.
    Sentry.configureScope(scope => scope.setUser(null))
    setIsUserSet(false)
  }

  return {
    stopTrackingSentry,
  }
}
